import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ILogin, IForgetPassword, IVerifyCode } from '../models/auth.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl + 'Auth/';

  constructor(private http: HttpClient) { }
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }
  login(userName: string, password: string): Observable<any> {
    const body: ILogin = {
      userName,
      password
    }; 
    return this.http.post(`${this.apiUrl}login`, body, {
      headers: { 'No-Auth': 'true' }
    });
  }

  forgetPassword(countryCode: string, phoneNumber: string): Observable<any> {
    const body: IForgetPassword = { countryCode, phoneNumber };
    return this.http.post(`${this.apiUrl}forget-password`, body, {
      headers: { 'No-Auth': 'true' }
    });
  }

  verifyCode(countryCode: string, phoneNumber: string, code: string): Observable<any> {
    const body: IVerifyCode = { phone: { countryCode, phoneNumber }, code };
    return this.http.post(`${this.apiUrl}verify`, body, {
      headers: { 'No-Auth': 'true' }
    });
  }

  resetPassword(password: string, token: string): Observable<any> {
    return this.http.post(`${this.apiUrl}reset-password`, null, {
      params: { password },
      headers: { Authorization: `Bearer ${token}` }
    });
  }

}
